import React, { useMemo } from 'react'
import { useTable, useBlockLayout } from 'react-table'
import { useSticky } from 'react-table-sticky'
import styled from 'styled-components'

const Styles = styled.div`
  max-width: 95vw;
  max-height: 60vh;
  overflow: auto;

  .table {
    border: 1px solid #ddd;

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }

    .th,
    .td {
      padding: 5px;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #ddd;
      background-color: #fff;
      overflow: hidden;

      :last-child {
        border-right: 0;
      }
    }

    &.sticky {
      overflow: scroll;
      .header,
      .footer {
        position: sticky;
        z-index: 1;
        width: fit-content;
      }

      .header {
        top: 0;
        box-shadow: 0px 3px 3px #ccc;
      }

      .footer {
        bottom: 0;
        box-shadow: 0px -3px 3px #ccc;
      }

      .body {
        position: relative;
        z-index: 0;
      }

      [data-sticky-td] {
        position: sticky;
      }

      [data-sticky-last-left-td] {
        box-shadow: 2px 0px 3px #ccc;
      }

      [data-sticky-first-right-td] {
        box-shadow: -2px 0px 3px #ccc;
      }
    }
  }
`

const Tabla = ({ columns, data }) => {
  const defaultColumn = useMemo(
    () => ({
      minWidth: 40,
      maxWidth: 800,
    }),
    [],
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data, defaultColumn }, useBlockLayout, useSticky)

  const footerGroups = headerGroups.slice().reverse()

  return (
    <Styles>
      <div
        {...getTableProps()}
        className="table sticky"
        style={{ width: 800, height: 400 }}>
        <div className="header">
          {headerGroups.map(headerGroup => (
            <div className="tr" {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <div className="th" {...column.getHeaderProps()}>
                  {column.render('Header')}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="body" {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row)
            return (
              <div className="tr" {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return (
                    <div className="td" {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      </div>
    </Styles>
  )
}

export default Tabla
